/* Lead pipeline status (mini-CRM). Stored in D1 as the lead's overlay state,
   preserved across BigQuery syncs. */
import type { BadgeVariant } from '@/components/ui';

export type LeadStatus = 'unworked' | 'worked' | 'proposal_sent' | 'sold' | 'lost';

export const LEAD_STATUSES: { value: LeadStatus; label: string; variant: BadgeVariant }[] = [
  { value: 'unworked', label: 'Unworked', variant: 'neutral' },
  { value: 'worked', label: 'Worked', variant: 'accent' },
  { value: 'proposal_sent', label: 'Proposal Sent', variant: 'warning' },
  { value: 'sold', label: 'Sold', variant: 'success' },
  { value: 'lost', label: 'Lost', variant: 'outline' },
];

export const STATUS_META: Record<LeadStatus, { label: string; variant: BadgeVariant }> = Object.fromEntries(
  LEAD_STATUSES.map((s) => [s.value, { label: s.label, variant: s.variant }]),
) as Record<LeadStatus, { label: string; variant: BadgeVariant }>;

export function isValidStatus(s: string): s is LeadStatus {
  return LEAD_STATUSES.some((x) => x.value === s);
}
